import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var renderInputs = function (inputs, uniqueId) {
    if (uniqueId === void 0) { uniqueId = null; }
    var identifier = uniqueId ? "".concat(uniqueId, "_") : "";
    return inputs.map(function (input) { return (_jsxs("div", { className: input.type === "checkbox" ? "checkbox-field" : "form-field", children: [_jsx("label", { htmlFor: "".concat(identifier).concat(input.id), className: "font-bold text-slate", children: input.label }), _jsx("input", { id: "".concat(identifier).concat(input.id), className: "rounded-xl border border-sherpaChocoCream bg-white px-4 py-3 text-sm text-ink outline-none transition placeholder:text-mutedBlue/60 focus:border-primary focus:ring-2 focus:ring-primary/10", type: input.type || "text", placeholder: input.placeholder, name: "".concat(identifier).concat(input.name), required: input.required || false })] }, input.id)); });
};
export var commonAddressInputs = [
    { id: "street", name: "street", placeholder: "Enter Street", label: "Street" },
    { id: "city", name: "city", placeholder: "Enter City", label: "City" },
    { id: "state", name: "state", placeholder: "Enter State", label: "State" },
    { id: "zipcode", name: "zipcode", placeholder: "Enter Zipcode", label: "Zipcode" },
];
export var streetAndCityInputs = commonAddressInputs.slice(0, 2);
export var stateAndZipcodeInputs = commonAddressInputs.slice(2);
export var businessNameInput = {
    id: "business_name",
    name: "business_name",
    placeholder: "Enter Business Name",
    label: "Business Name",
    type: "text",
};
export var registeredAgentOmitInput = {
    id: "omit_registered_agents",
    name: "omit_registered_agents",
    label: _jsx("p", { className: "mr-2", children: "Omit Registered Agents: " }),
    type: "checkbox",
};
export var commonPersonInputs = [
    { id: "first_name", name: "first_name", placeholder: "Enter First Name", label: "First Name" },
    {
        id: "middle_name",
        name: "middle_name",
        placeholder: "Enter Middle Name",
        label: "Middle Name",
    },
    { id: "last_name", name: "last_name", placeholder: "Enter Last Name", label: "Last Name" },
];
